<template>
  <b-button
    class="save-action-button btnStepNext"
    :aria-label="ariaLabel"
    :disabled="disabled"
    :loading="loading"
    :active="active"
    icon-left="floppy-disk"
    icon-pack="far"
    type="is-dark"
    @click="$emit('click')"
  />
</template>

<script lang="ts">
import { BButton } from "buefy";

/**
 * Bouton "Enregistrer" partage entre les formulaires d'edition utilisateur
 * ( EditPwd , EditEmail , et tout futur formulaire equivalent ) .
 *
 * <p>Encapsule l'identite visuelle :
 * <ul>
 *   <li>fond fonce ( {@code type="is-dark"} ) ;</li>
 *   <li>icone disquette ( {@code floppy-disk} de FA regular ) ;</li>
 *   <li>largeur fixe a 1/6 du conteneur ( equivalent Bulma {@code is-2}
 *       sur grille 12 colonnes ) afin que les boutons "save" de tous les
 *       formulaires aient strictement la meme dimension - voir le commit
 *       qui aligne EditEmail sur la largeur de EditPwd .</li>
 * </ul>
 *
 * <p>Positionnement = responsabilite du consommateur ( flex footer ,
 * Bulma columns , inline-block , ... ) . Le composant ne dicte que sa
 * largeur intrinseque .
 */
export default {
  name: "SaveActionButton",
  components: { BButton },
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    active: { type: Boolean, default: true },
    ariaLabel: { type: String, default: "" },
  },
  emits: ["click"],
};
</script>

<style scoped lang="scss">
/*
 * Largeur 16.66% = 2/12 ( Bulma grid is-2 ) . En contexte flex ( EditEmail
 * footer ) , {@code flex: 0 0 16.66%} fige le ratio ; en contexte block
 * ( EditPwd Form ) , {@code width: 16.66%} + margin auto suffit . On pose
 * les deux pour couvrir les deux usages sans surprise .
 *
 * {@code min-width} = garde-fou pour les tres petites resolutions ou
 * 16.66% rendrait l'icone illisible ( < 6rem ) .
 */
.save-action-button {
  flex: 0 0 16.66%;
  width: 16.66%;
  min-width: 6rem;
}
</style>
